import { BsCheck } from "react-icons/bs";
import { useDispatch } from "react-redux";
import { color_black_ultra_light } from "../../../../constants/colors";
import { OnestNormalMed } from "../../../styled/TextComponents";
import { styles } from "./Styles";

/**
 * Weekly task row
 * @param task
 * @param isLastTask is task last in a row. Printing border depends on it
 * @param toggleTaskCallBack function that would be call when user complete task with a click
 * @returns {JSX.Element}
 * @constructor
 */
export const WeeklyTaskRow = ({ task, isLastTask, toggleTaskCallBack }) => {
  const dispatch = useDispatch;

  return (
    <>
      <div
        style={{
          ...styles.weeklyTaskRow,
          ...(task.completed && styles.completedWeeklyTaskRow),
          ...(isLastTask && styles.lastWeeklyTaskRow), // Применяется последним, чтобы убрать border у последней задачи
        }}
      >
        <div
          style={{
            ...styles.weeklyTaskCircle,
            ...(task.completed && styles.completedWeeklyTaskCircle),
          }}
          onClick={() => {
            toggleTaskCallBack(task);
          }}
        >
          {task.completed ? <BsCheck /> : null}
        </div>
        <span
          style={{
            color: color_black_ultra_light,
            flexGrow: 1,
            ...(task.completed && styles.completedWeeklyTaskText),
          }}
        >
          <OnestNormalMed>{task.title}</OnestNormalMed>
        </span>
      </div>
    </>
  );
};
